import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { authActions, MailCheckType } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";

export const useRegistration = () => {
  const dispatch = useDispatch();
  const { navigateToPage, navigateToTopPage } = useNavigation();
  const { key } = useParams<{ key: string }>();
  const { state } = useLocation();

  const { type, value, name, phoneNumber, email } = state ?? {};

  useEffect(() => {
    if (!key) return;

    dispatch(appActions.showLoading());
    dispatch(
      authActions.verifyEmailKey.started({
        key,
        type: MailCheckType.Registration.valueOf(),
        onComplete: () => dispatch(appActions.hideLoading()),
        onError: navigateToTopPage,
      }),
    );
  }, []);

  const handleRegistration = useCallback(
    (
      name: string,
      phoneNumber: string,
      email: string,
      password: string,
      passwordConfirmation: string,
    ) => {
      navigateToPage(PageRoutes.CUSTOMER_INFO_CONFIRMATION, false, {
        key,
        type,
        value,
        name,
        phoneNumber,
        email,
        password,
        passwordConfirmation,
      });
    },
    [],
  );

  return { type, value, name, phoneNumber, email, handleRegistration };
};
